var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 20C4.47692 20 0 15.5233 0 10C0 4.47673 4.47692 0 10.0004 0C15.5231 0 20 4.47673 20 10C20 15.5233 15.5231 20 10.0004 20Z",
    fill: "#0076A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.00098 12C11.55326 12 12.00098 11.55228 12.00098 11C12.00098 10.4477 11.55326 10 11.00098 10C10.4487 10 10.00098 10.4477 10.00098 11C10.00098 11.55228 10.4487 12 11.00098 12ZM11.00098 22C11.55326 22 12.00098 21.5523 12.00098 21L12.00098 15C12.00098 14.4477 11.55326 14 11.00098 14C10.4487 14 10.00098 14.4477 10.00098 15V21C10.00098 21.5523 10.4487 22 11.00098 22Z",
    fill: "white",
    transform: "translate(-1 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.3a3eeadd5e52358531ad98af1128893f.svg";
export { ForwardRef as ReactComponent };